export const EDITABLE_TAGS = new Set(['INPUT', 'SELECT', 'TEXTAREA'])

export const MODIFIERS = {
  altKey: 'altKey',
  shiftKey: 'shiftKey',
  ctrlKey: 'ctrlKey',
  metaKey: 'metaKey',
} as const
